/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    // reset each group
    document.querySelectorAll(".miniCartBodyGroup").forEach(element => element.innerHTML = "");

    // fetch cart
    if (skipFetch === false) {
        cart = await fetch("/cart.js")
            .then(function (data) {
                return data.json();
            });
    }

    // max quantity for chemical check
    if (localStorage.getItem("chemicals")) {
        // parse chemicals from localstorage
        const chemicals = JSON.parse(localStorage.chemicals);

        // loop through each chemical in the cart
        for (const item of cart.items) {
            // find the matching chemical based on sku
            const chemical = chemicals.find(chemical => chemical.heritageSKU === item.sku);

            // if chemical is found and delivery type is set
            if (chemical && item.properties?._deliveryType) {
                // determine available quantity based on delivery type
                const availableQuantity = chemical.availability[item.properties._deliveryType] || 0;

                // if current quantity is more than available quantity, update cart and exit
                if (item.quantity > availableQuantity) {
                    cart = await updateCart({updates: {[item.key]: availableQuantity}});
                    await openCart(true);
                    return;
                }
            }
        }
    }

    // max quantity for each product
    for (const item of cart.items) {
        if (productToMaxQuantity[item.product_id] && item.quantity > productToMaxQuantity[item.product_id]) {
            cart = await updateCart({updates: {[item.key]: 1}});
            await openCart(true);
            return;
        }
    }

    // GA4 view_cart
    dataLayer.push({ecommerce: null});
    dataLayer.push({
        event: "view_cart",
        ecommerce: {
            subscription_included: cart.items.filter(item => item.selling_plan_allocation).length > 0,
            contains_upsell: cart.items.filter(item => item?.properties?.upsell).length > 0,
            currency: Shopify.currency.active,
            value: cart.total_price / 100,
            items: cart.items.map(function (item) {
                return {
                    item_id: item.product_id,
                    item_name: item.product_title,
                    item_variant: item.variant_title,
                    item_category: item.type,
                    price: item.price / 100,
                    quantity: item.quantity,
                    subscription_item: item.selling_plan_allocation !== undefined,
                    item_upsell: item.properties?._upsell,
                    item_upsell_location: item.properties?._upsell_location,
                }
            }),
        }
    });

    // open cart
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // hide all parts of the cart
    document.querySelector("#headerCart").removeAttribute("count");
    document.querySelector("#miniCartBody").classList.remove("active");
    document.querySelector("#miniCartUpsell").classList.remove("active");
    document.querySelector("#miniCartEmpty").classList.remove("active");
    document.querySelector("#miniCartFooter").classList.remove("active");

    // empty cart, exit
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        return;
    }

    // update active sections
    document.querySelector("#headerCart").setAttribute("count", cart.item_count);
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    // there are 3 product groups (general WG products, chemicals by branch, and chemicals by distribution center)
    const groups = {
        general: {
            items: [],
            subtotal: 0,
            header: `Standard shipping: <b>Free</b> with $75 orders`,
            footer: `Standard Shipping Subtotal: `
        },
        branch: {
            items: [],
            subtotal: 0,
            header: `Same day delivery: <b>Free</b> with $75 chemical orders`,
            footer: `Same Day Subtotal: `
        },
        distributionCenter: {
            items: [],
            subtotal: 0,
            header: `Standard shipping: <b>Free</b> with $75 chemical orders`,
            footer: `Standard Shipping Subtotal: `
        }
    };

    // append item to the DOM in the correct group
    cart.items.forEach(function (item) {
        // determine item group and push to group object
        let group;
        if (item.properties && item.properties._deliveryType === "branch") {
            group = "branch";
        } else if (item.properties && item.properties._deliveryType === "distributionCenter") {
            group = "distributionCenter";
        } else {
            group = "general";
        }
        groups[group].items.push(item);

        // update url for each item to include the group
        const productParams = new URLSearchParams();
        productParams.append("variant", item.variant_id);
        if (group !== "general") {
            productParams.append("deliveryType", group);
        }
        item.url = `/products/${item.handle}?${productParams.toString()}`;

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyGroupItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        // qunaitity HTML
        function quantityHTML() {
            if (item.handle === "waterguru-test-free") {
                return `<div class="miniCartBodyGroupItemQuantityCount bundle">QTY: ${item.quantity}</div>`
            } else {
                // disable plus button if max quantity is reached for
                let disable = "";
                if (productToMaxQuantity[item.product_id] && item.quantity >= productToMaxQuantity[item.product_id]) {
                    disable = "disabled"
                }

                return `
                    <div class="miniCartBodyGroupItemQuantity">
                        <button class="miniCartBodyGroupItemQuantityMinus">-</button>
                        <div class="miniCartBodyGroupItemQuantityCount">${item.quantity}</div>
                        <button class="miniCartBodyGroupItemQuantityPlus" ${disable}>+</button>
                    </div>
                `;
            }
        }

        // price html
        function priceHTML() {
            let HTML = price(item.final_line_price) + " ";

            // check for subscription
            if (item.selling_plan_allocation) {
                // calculate comapre price
                const comparePrice = item.selling_plan_allocation.compare_at_price * item.quantity;

                // check if compare price is > than final price
                if (comparePrice > item.final_line_price) {
                    // add compare price
                    HTML += ` <s>${price(comparePrice)}</s>`;

                    // calculate savings
                    HTML += ` <br>${(1 - (item.final_line_price / comparePrice)).toFixed(2) * 100}% OFF`;
                }
            }

            // check for line item discount
            else if (item.original_line_price > item.final_line_price) {
                HTML += `<s>${price(item.original_line_price)}</s>`;
            }
            // check for compare at price
            else if (variantToComparePrice[item.variant_id]) {
                HTML += `<s>${price(variantToComparePrice[item.variant_id] * item.quantity)}</s>`;
            }

            return HTML;
        }

        document.querySelector(`.miniCartBodyGroup[data-group="${group}"]`).insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyGroupItem" key="${item.key}">
                <img class="miniCartBodyGroupItemImage" src="${item.image}&width=200" alt="${item.product_title}">
                <div>
                    <a class="miniCartBodyGroupItemTitle" href="${item.url}">${item.product_title}</a>
                    ${subscriptionHTML()}
                    ${quantityHTML()}
                </div>
                <div>
                    <div class="miniCartBodyGroupItemPrice">${priceHTML()}</div>
                    <button class="miniCartBodyGroupItemRemove">remove</button>
                </div>
            </div>
        `);
    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyGroupItem`).forEach(function (element) {
        // get key
        let key = element.getAttribute("key");

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyGroupItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyGroupItemQuantityMinus")?.addEventListener("click", function () {
            if (quantity == 1) {
                element.querySelector(".miniCartBodyGroupItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyGroupItemQuantityPlus")?.addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyGroupItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();

            // fade out
            element.classList.add("fade");
        });

        // update quantity function
        async function updateCartItem() {
            // prevent future clicks
            element.classList.add("noClick");

            // update label
            element.querySelector(`.miniCartBodyGroupItemQuantityCount`).textContent = quantity;

            // update cart in shopify
            cart = await changeProduct({
                id: key,
                quantity: quantity
            });

            // update active body
            await openCart(true);
        }
    });

    // calculate subtotal for each group
    let activeGroups = 0;
    for (const group in groups) {
        // skip if group is empty
        if (groups[group].items.length === 0) {
            continue;
        }

        // increment active groups
        activeGroups++;

        // calculate subtotal
        groups[group].subtotal = groups[group].items.reduce((acc, item) => acc + item.final_line_price, 0);
    }

    // if there are multiple groups
    if (activeGroups > 1) {
        // loop through each group
        for (const group in groups) {
            // skip if group is empty
            if (groups[group].items.length === 0) {
                continue;
            }

            // add header and footer
            document.querySelector(`.miniCartBodyGroup[data-group="${group}"]`).insertAdjacentHTML("beforeend", `
                <div class="miniCartBodyGroupHeader">${groups[group].header}</div>
                <div class="miniCartBodyGroupFooter">${groups[group].footer} ${price(groups[group].subtotal)}</div>
            `);
        }

        // update header
        document.querySelector("#miniCartHeaderShipments").textContent = `Your order ships as ${activeGroups} separate deliveries`;
    } else {
        // remove header
        document.querySelector("#miniCartHeaderShipments").textContent = "";
    }

    // check if this order has any cassette and has a sense s2
    const hasCassette = cart.items.filter(item => item.handle.includes("cassette")).length > 0;
    const hasSenseS2 = cart.items.filter(item => item.handle === "waterguru-sense").length > 0;

    // show upsell if this order does not have any cassette
    if (upsellProduct && !hasCassette && hasSenseS2) {
        document.querySelector("#miniCartUpsell").classList.add("active");

        // track
        dataLayer.push({ecommerce: null});
        dataLayer.push({
            event: "view_item",
            ecommerce: {
                contains_upsell: true,
                currency: Shopify.currency.active,
                price: upsellProduct.price / 100,
                items: [
                    {
                        item_id: upsellProduct.variants[0].id,
                        item_name: upsellProduct.title,
                        item_variant: upsellProduct.variants[0].title,
                        item_category: upsellProduct.variants[0].type,
                        price: upsellProduct.price / 100,
                        quantity: 1,
                        item_upsell: true,
                        item_upsell_location: "mini_cart",
                    }
                ]
            }
        });
    }

    // update textarea
    let hasChemicals = cart.items.filter(item => {
        return item.sku != null && !item.sku.includes("WG-");
    });
    if (hasChemicals.length > 0) {
        document.querySelector("#miniCartFooterNote").classList.add("active");
        document.querySelector("#miniCartFooterNoteTextarea").value = cart.note;
    } else {
        document.querySelector("#miniCartFooterNote").classList.remove("active");
        document.querySelector("#miniCartFooterNoteTextarea").value = "";
    }

    // update subtotal
    document.querySelector("#miniCartFooterSubtotal span:last-child").textContent = price(cart.items_subtotal_price);
}

// close cart
function closeCart() {
    document.querySelector("#miniCart").close();
    document.querySelector("body").classList.remove("noScroll");
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function () {
        openCart();
    });
});

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    // start loading
    this.classList.add("loading");

    // GA4 begin_checkout
    dataLayer.push({ecommerce: null});
    dataLayer.push({
        event: "begin_checkout",
        ecommerce: {
            subscription_included: cart.items.filter(item => item.selling_plan_allocation).length > 0,
            contains_upsell: cart.items.filter(item => item?.properties?.upsell).length > 0,
            currency: Shopify.currency.active,
            value: cart.total_price / 100,
            items: cart.items.map(function (item) {
                return {
                    item_id: item.product_id,
                    item_name: item.product_title,
                    item_variant: item.variant_title,
                    item_category: item.type,
                    price: item.price / 100,
                    quantity: item.quantity,
                    subscription_item: item.selling_plan_allocation !== undefined,
                    item_upsell: item.properties?._upsell,
                    item_upsell_location: item.properties?._upsell_location,
                }
            }),
        }
    });

    // update order note if it does not match shopify
    if (document.querySelector("#miniCartFooterNoteTextarea").value !== cart.note) {
        await updateCart({"note": document.querySelector("#miniCartFooterNoteTextarea").value});
    }

    // stop loading
    this.classList.remove("loading");

    window.location.href = "/checkout";
});

// upsell event listener
document.querySelector("#miniCartUpsellButton").addEventListener("click", async function () {
    // determine which upsell_purchase is selected
    const purchaseType = document.querySelector(`.miniCartUpsellGridFormSubscriptionLabelInput:checked`)?.value;

    // alert if no upsell_purchase is selected
    if (!purchaseType) {
        alert("Please select one time or subscription.");
        return;
    }

    // start loading
    this.classList.add("loading");

    // aggregate form data
    let formdata = {
        id: upsellProduct.variants[0].id,
        selling_plan: purchaseType === "subscription" ? upsellProduct.selling_plan_groups[0].selling_plans[0].id : null,
        quantity: 1,
        properties: {
            "_upsell": true,
            "_upsell_location": "mini_cart"
        }
    };

    // trigger dataLayer track
    dataLayer.push({ecommerce: null});
    dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
            subscription_included: purchaseType === "subscription",
            contains_upsell: true,
            value: upsellProduct.price / 100,
            currency: Shopify.currency.active,
            items: [{
                item_id: upsellProduct.id,
                item_name: upsellProduct.title,
                item_variant: upsellProduct.variants[0].title,
                item_category: upsellProduct.type,
                price: upsellProduct.price / 100,
                quantity: 1,
                subscription_item: purchaseType === "subscription",
                item_upsell: true,
                item_upsell_location: "mini_cart"
            }],
        }
    });

    // add to cart
    await addProduct(formdata);

    // refresh cart
    await openCart();

    // stop loading
    this.classList.remove("loading");
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));

// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart();
}